import { env } from './env';

/**
 * Whether the STRESS debug hooks (currently `__SIRONA_APOLLO_CACHE__` and the instrumented Apollo
 * cache) may mount.
 *
 * Requires a non-production build AND a runtime opt-in that the STRESS harness sets on the page
 * before app code runs (Playwright `addInitScript`). Ordinary dev, staging and preview sessions
 * never set it, so they run the same plain Apollo cache as production. Those environments can hold
 * real patient data, so debug hooks stay off unless a STRESS run asks for them.
 *
 * Read at call time: the opt-in is a per-page runtime signal, so no rebuild is needed.
 */
export const isStressDebugHooksEnabled = (): boolean =>
  env.DEPLOY_ENV !== 'production' &&
  typeof window !== 'undefined' &&
  window.__SIRONA_STRESS_OPT_IN__ === true;
